import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class LocationDetailsService {
  constructor(private afs: AngularFirestore) {}

  public getscreenListing(screenListingId: string): Observable<any> {
    return this.afs.doc(`screens/${screenListingId}`).valueChanges();
  }

  public getUserInfo(userId: string): Observable<any> {
    return this.afs.doc(`users/${userId}`).valueChanges();
  }
}
